import CripNotice from "crip-vue-notice";

export var tradeCallback = {
  data() {
    return {
      reco_data: "",
      websiteUserType: localStorage.getItem("websiteUserType") ? JSON.parse(
        localStorage.getItem("websiteUserType")
      ) : {}
    };
  },
  methods: {
    goToTradePage(stockDetails, index) {
      console.log(stockDetails);
      
      var selected_leg = stockDetails.data[index];

      // set parameters for pre selected stock in trade button
      var stockData = {};
      stockData.segment = "options";
      stockData.title = stockDetails.strategy.title;
      stockData.stock_id = stockDetails.strategy.id;
      stockData.leg_id = selected_leg.stock.id;
      stockData.expiry = stockDetails.strategy.expiry;
      stockData.stop_loss = selected_leg.stop_loss;
      stockData.target_price = selected_leg.target_premium;
      stockData.order_type = selected_leg.direction;
      stockData.stock = selected_leg.stock;
      stockData.entry_premium = selected_leg.entry_premium;
      stockData.entryPrice = selected_leg.entry_premium;
      stockData.strategy_id = stockDetails.strategy.id;

      const currentDate = new Date();
      const expiry = new Date(stockData.expiry);

      if (this.isTradeVisible()) {
        this.$store.commit("commitTradeMenu", "TRADE");
        this.$store.commit("commitSelectedOrder", stockData);


        if (expiry >= currentDate) {
          this.$store.commit("tradePopupAction", true);
          this.isDataChanged = true;
        } else {
          new CripNotice({
            title: "This trade has been expired",
            description: "To place order, check other strategies.",
            type: "info",
            duration: 3,
          });
        }
      } else {
        if (this.websiteUserType.userType !== "broker") {
          
          if (expiry >= currentDate) {
            this.$store.commit("commitBrokerLoginDialogVisibility", true);
            this.$store.commit("commitSelectedOrder", stockData);
          } else {
            new CripNotice({
              title: "This trade has been expired",
              description: "To place order, check other strategies.",
              type: "info",
              duration: 3,
            });
          }

        } else {
          this.$store.commit("commitSubscribPlanDialogVisibility", true);
        }
      }
    },

    getTradeHostDetails() {
      this.$store.commit("commitHybridBrokerLoginDialogVisibility", true);
    },

    openLeaveConfirmationPopup() {
      this.leaveSiteConfirmationPopup = true;
    },

    exitReco(reco_id, index) {
      this.exitRecoCallBack(reco_id, index);
    },

    editReco(reco_data, index) {
      this.$store.commit("optionEditStockData", reco_data);

      this.$router.push({ path: "/publish-recommendation-options" });

    },
  },
};
